import {
  Box,
  Button,
  ButtonGroup,
  Divider,
  toggleButtonGroupClasses
} from "@material-ui/core";
import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/styles";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";

const useStyles = makeStyles(theme => ({
  controlsWrapper: {
    position: "absolute",
    width: theme.spacing(5),
    zIndex: 400,
    right: 24,
    bottom: 24
  },
  shadow: {
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.16)"
  },
  roundedLg: {
    borderRadius: theme.spacing(0.75),
    overflow: "hidden",
    "& .MuiButton-contained:hover": {
      boxShadow: "none"
    }
  },
  bgWhite: {
    backgroundColor: "#fff"
  },
  controlBtn: {
    backgroundColor: "#fff",
    textTransform: "none",
    width: 40,
    height: 40,
    minWidth: 0,
    color: "#5F6368",
    padding: 0,
    "&:hover": {
      backgroundColor: "#F7F7F7",
      boxShadow: theme.shadows[2]
    }
  },
  zoomBtn: {
    height: 39
  },
  divider: {
    margin: theme.spacing(0, 1.125),
    backgroundColor: "#EEE",
    opacity: 0.75
  }
}));

export default function Controls({ mapRef }: { mapRef: any }) {
  const classes = useStyles();
  return (
    <ButtonGroup
      size="small"
      orientation="vertical"
      className={classes.controlsWrapper}
    >
      <Button
        onClick={() => {
          const lf = mapRef.current;
          const currentZoom = lf.getZoom();
          lf.setZoom(currentZoom + 1);
        }}
        className={clsx(classes.controlBtn, classes.zoomBtn)}
        variant="contained"
      >
        <AddIcon />
      </Button>
      <Button
        onClick={() => {
          const lf = mapRef.current;
          const currentZoom = lf.getZoom();
          lf.setZoom(currentZoom - 1);
        }}
        className={clsx(classes.controlBtn, classes.zoomBtn)}
        variant="contained"
      >
        <RemoveIcon />
      </Button>
    </ButtonGroup>
  );
}
